<template>
  <LoginForm />
</template>

<script>
import LoginForm from '@/components/user/LoginForm.vue';

export default {
  components: {
    LoginForm,
  },
}
</script>

<style></style>